import axios from 'axios';
import {backendHost} from '../../config';

export const getDashboardWithdrawals = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/dashboard/withdrawals`, {params});
};